import axios from 'axios';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import type { TokenListPayload, TokenListResponse } from './Model';

type InitialState = {
  loading: boolean;
  response: TokenListResponse;
  successMsg: string;
  error: string;
};

const initialState: InitialState = {
  loading: false,
  response: {} as TokenListResponse,
  successMsg: '',
  error: '',
};

// Extended payload type to include date filters
export interface TokenListPayloadWithDates extends TokenListPayload {
  startDate?: string;
  endDate?: string;
}

export const tokenList = createAsyncThunk<TokenListResponse, TokenListPayloadWithDates>(
  'tokenList/tokenList',
  async (payload: TokenListPayloadWithDates, { rejectWithValue }) => {
    try {
      const baseUrl = 'https://erp-ssssh.technicise.eu';
      const accessToken = '3703265d357a211:5b86c8948ff269d';

      // Build filters array
      const filters: any[] = [['docstatus', '=', 0]];
      
      if (payload.startDate && payload.endDate) {
        filters.push(['in_time', '>=', payload.startDate]);
        filters.push(['in_time', '<=', payload.endDate]);
      }

      const params: any = {
        fields: '["visitor_name","visitor_middle_name","visitor_last_name","token_number","name", "phone_number","docstatus","department","patient_id_card_number","in_time","out_time","father__husband__guardian_1","father_last_name","guardian_1_id_card_number","guardian_1_rfid_number","mother__guardian_2","mother_guardian_2_last_name","guardian_2_id_card_number","guardian_2_rfid_number"]',
        filters: JSON.stringify(filters),
        ['order_by']: 'in_time desc'
      };

      const response = await axios.get(
        `${baseUrl}/api/resource/${payload.doctype}`, 
        {
          params,
          headers: {
            'Accept': 'application/json',
            'Authorization': `token ${accessToken}`
          }
        }
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || 'Failed to fetch patient data'
      );
    }
  }
);

const tokenListSlice = createSlice({
  name: 'tokenList',
  initialState,
  reducers: {
    updateTokenListClearMsg: (state) => {
      state.successMsg = '';
      state.error = '';
    },
    updateTokenListClearRes: (state) => {
      state.successMsg = '';
      state.error = '';
      state.response = {} as TokenListResponse;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(tokenList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      tokenList.fulfilled,
      (state, action: PayloadAction<TokenListResponse>) => {
        state.loading = false;
        state.response = action.payload;
        state.successMsg = 'Token details fetched successfully';
      },
    );
    builder.addCase(tokenList.rejected, (state, action) => {
      state.loading = false;
      state.response = {} as TokenListResponse;
      state.successMsg = '';
      state.error = String(action.payload) || 'Something went wrong';
    });
  },
});

export const { updateTokenListClearMsg, updateTokenListClearRes } =
  tokenListSlice.actions;
export default tokenListSlice.reducer;